import { NavLink } from "react-router-dom";
import Button from "../button/button";

const LoggedOut = () => {
  return (
    <div className="flex gap-4">
      <NavLink to={"/login"}>
        <Button size="small" variant="primary">
          Sign In
        </Button>
      </NavLink>
      <NavLink to={"/signup"}>
        <Button size="small" variant="outline">
          Join us
        </Button>
      </NavLink>
    </div>
  );
};

export default LoggedOut;
